import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router/index'
import store from './store'

import '../style.css'

createApp(App).use(store).use(router).mount('#app')
